export default "__VITE_ASSET__DNbruPEG__"